import React from "react";
import { useLocation } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react"; // Import PersistGate
import { Provider, useSelector } from "react-redux";
import Header from "./components/headerWithSidebar";
import AppRoutes from "./routes/AppRoutes";
import store, { persistor } from "./redux/store";
import { selectServiceType } from "./redux/features/customer/customerSelectors";
import { selectBrandsList, selectCateringRestaurantId } from "./redux/features/restaurants/restaurantSelectors";

function App() {
  const location = useLocation();
  const serviceType = useSelector(selectServiceType);
  const cateringRestaurantId = useSelector(selectCateringRestaurantId);
  const brandList = useSelector(selectBrandsList);

  // Define public routes that shouldn't show the agent header
  const publicRoutes = ['/catering-order-complete', '/catering-order-failed', '/login', '/'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  const headerTexts = {
    "/register": "Place Order",
    "/promocode": "User Setting",
    "/search": "Place Order",
    "/main-page": "Main Page",
    "/catering-page": "Catering Order",
    "/catering-order": "Catering Order",
    "/catering-packages": brandList && cateringRestaurantId 
      ? (brandList.find(brand => brand.id == cateringRestaurantId)?.name_en || "Restaurant") + " Catering"
      : "Catering",
    "/catering-checkout": "Checkout",
    "/catering-calendar": "Catering Orders Calendar",
    "/place-order": serviceType === "delivery" ? "Delivery Order" : "Pickup Order",
  };

  // Handle dynamic catering package detail route
  let headerText = headerTexts[location.pathname] || " ";
  if (location.pathname.startsWith("/catering-package/")) {
    headerText = brandList && cateringRestaurantId 
      ? (brandList.find(brand => brand.id == cateringRestaurantId)?.name_en || "Restaurant") + " Catering Package"
      : "Catering Package";
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div>
          {/* Only show header for non-public routes */}
          {!isPublicRoute && <Header headerText={headerText} />}
          <div>
            <AppRoutes />
          </div>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
